import config from '../config'

const DEFAULT_AMP_CONFIG = {
  key: null,
  v: '1.4.15',
  protocol: 'https',
  host: 'webapi.amap.com/maps',
  plugin: ['Autocomplete','PlaceSearch', 'PolyEditor','RectangleEditor', 'CircleEditor','MouseTool','GraspRoad','Geocoder','DistrictSearch','GeometryUtil','Heatmap'],
  uiVersion:'1.1',
  callback: 'amapInit'
};

class AMapLoader {
  constructor(config) {
    this._config = {
      ...DEFAULT_AMP_CONFIG,
      ...config
    };
    this._document = document;
    this._window = window;
    this._scriptLoaded = false;
  }

  load() {
    if (this._window.AMap && this._window.AMap.Map) {
      return this.loadUIAMap()
    }

    if (this._scriptLoadingPromise) return this._scriptLoadingPromise;
    const script = this._document.createElement('script');
    script.type = 'text/javascript';
    script.async = false;
    // script.defer = true;
    script.src = this._getScriptSrc();

    const UIPromise = this._config.uiVersion ? this.loadUIAMap() : null;

    this._scriptLoadingPromise = new Promise((resolve, reject) => {
      this._window['amapInit'] = () => {
        if (UIPromise) {
          UIPromise.then(() => {
            // window.initAMapUI();
            setTimeout(resolve,0);
          });
        } else {
          return resolve();
        }
      };
      script.onerror = error => reject(error);
    });
    this._document.head.appendChild(script);
    return this._scriptLoadingPromise;
  }

  loadUIAMap() {
    if (!this._config.uiVersion || window.AMapUI) return Promise.resolve();
    return new Promise((resolve, reject) => {
      const UIScript = document.createElement('script');
      const [versionMain, versionSub, versionDetail] = this._config.uiVersion.split('.');
      if (versionMain === undefined || versionSub === undefined) {
        console.error('amap ui version is not correct, please check! version: ', this._config.uiVersion);
        return;
      }
      // let src = `${this._config.protocol}://webapi.amap.com/ui/${versionMain}.${versionSub}/main-async.js`;
      let src = `${this._config.protocol}://webapi.amap.com/ui/${versionMain}.${versionSub}/main.js`;
      if (versionDetail) src += `?v=${versionMain}.${versionSub}.${versionDetail}`;
      UIScript.src = src;
      UIScript.type = 'text/javascript';
      UIScript.async = false;
      setTimeout(() => {
        this._document.head.appendChild(UIScript);
      },0)
      UIScript.onload = () => {
        setTimeout(resolve, 0);
      };
      UIScript.onerror = () => reject();
    });
  }

  _getScriptSrc() {
    // amap plugin prefix reg
    const amap_prefix_reg = /^AMap./;

    const config = this._config;
    const paramKeys = ['v', 'key', 'plugin', 'callback'];

    // check 'AMap.' prefix
    if (config.plugin ) {

      config.plugin = config.plugin.map(item => {
        return (amap_prefix_reg.test(item)) ? item : 'AMap.' + item;
      });
    }

    const params = Object.keys(config)
      .filter(k => ~paramKeys.indexOf(k))
      .filter(k => config[k] != null)
      .filter(k => {
        return !Array.isArray(config[k]) ||
          (Array.isArray(config[k]) && config[k].length > 0);
      })
      .map(k => {
        let v = config[k];
        if (Array.isArray(v)) return { key: k, value: v.join(',') };
        return { key: k, value: v };
      })
      .map(entry => `${entry.key}=${entry.value}`)
      .join('&');
    return `${this._config.protocol}://${this._config.host}?${params}`;
  }

}

const lazyLoader = new AMapLoader(config)

export default lazyLoader